module.exports = __webpack_public_path__ + "assets/notification.40c62bfa294372fcba971053d24bd0f3.svg";